import { defineMessages } from 'react-intl';

const messages = defineMessages({
    accessStatsViewDetails: {
        defaultMessage: 'View Details',
        description: 'The text in the link in the sidebar to open up the access stats popup',
        id: 'boxui.accessStats.accessStatsViewDetails',
    },
    accessStatsViews: {
        defaultMessage: 'Views',
        description: 'The label for the view category of access stats for box notes',
        id: 'boxui.accessStats.accessStatsViews',
    },
    accessStatsPreviews: {
        defaultMessage: 'Previews',
        description: 'The label for the preview category of access stats',
        id: 'boxui.accessStats.accessStatsPreviews',
    },
    accessStatsEdits: {
        defaultMessage: 'Edits',
        description: 'The label for the edit category of access stats',
        id: 'boxui.accessStats.accessStatsEdits',
    },
    accessStatsComments: {
        defaultMessage: 'Comments',
        description: 'The label for the comments category of access stats',
        id: 'boxui.accessStats.accessStatsComments',
    },
    accessStatsDownloads: {
        defaultMessage: 'Downloads',
        description: 'The label for the downloads category of access stats',
        id: 'boxui.accessStats.accessStatsDownloads',
    },
});

export default messages;
